export const SectionLabel = ({ index, children, dark = false }) => (
  <p className={`eyebrow flex items-center gap-3 ${dark ? "text-lime" : "text-royal"}`}>
    {index && <span className={dark ? "text-white/60" : "text-slatey"}>({index})</span>}
    <span className={`h-px w-8 ${dark ? "bg-lime" : "bg-royal"}`} aria-hidden="true" />
    {children}
  </p>
);
